"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoDiscount = void 0;
const CountryTier_1 = require("../definitions/CountryTier");
const BaseDiscount_1 = require("./BaseDiscount");
class NoDiscount extends BaseDiscount_1.BaseDiscount {
    canHandle(criteria) {
        return true;
    }
    handle() {
        return { percentage: 0, countryTier: CountryTier_1.CountryTier.INELIGIBLE };
    }
}
exports.NoDiscount = NoDiscount;
